import Vue from 'vue'
import Stock from '../plugins/stock'
import config from '@/config'
// import logger from 'vendor/logger'

Vue.use(Stock)

export default new Stock(config.stock)



// WEBPACK FOOTER //
// ./src/plugin-config/stock.js